import { jsPDF } from "jspdf";
import { drawFreshEarthSeal } from "./pdfLogo";

const FOREST = [26, 43, 34];
const TERRA = [184, 101, 81];
const BONE = [247, 246, 240];
const INK = [28, 28, 28];
const SLATE = [92, 94, 85];
const STONE = [138, 140, 130];

// Procurement-ready tender / specification sheet.
export function generateTenderPdf() {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const W = 595;
  const M = 48;
  let y;

  const header = () => {
    doc.setFillColor(...FOREST);
    doc.rect(0, 0, W, 96, "F");
    drawFreshEarthSeal(doc, { x: M, y: 20, size: 56, tone: "light" });
    doc.setTextColor(...BONE);
    doc.setFont("times", "italic");
    doc.setFontSize(22);
    doc.text("Fresh Earth", M + 68, 50);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.setTextColor(220, 224, 214);
    doc.text("OED — Odour Eliminator & Decomposer", M + 68, 66);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(9);
    doc.setTextColor(...TERRA);
    doc.text("TENDER / SPECIFICATION SHEET", W - M, 44, { align: "right" });
  };

  const section = (title) => {
    y += 10;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    doc.setTextColor(...STONE);
    doc.text(title, M, y);
    y += 8;
    doc.setDrawColor(210, 210, 200);
    doc.line(M, y, W - M, y);
    y += 18;
  };

  const row = (k, v) => {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.setTextColor(...SLATE);
    doc.text(k, M, y);
    doc.setTextColor(...INK);
    const lines = doc.splitTextToSize(v, W - M - 210);
    doc.text(lines, M + 200, y);
    y += Math.max(18, lines.length * 13 + 5);
  };

  header();
  y = 128;
  doc.setTextColor(...INK);
  doc.setFont("times", "normal");
  doc.setFontSize(20);
  doc.text("Product & performance specification", M, y);
  y += 24;

  section("PRODUCT SPECIFICATION");
  row("Product", "OED — Odour Eliminator & Decomposer");
  row("Type", "Liquid microbial diversity bio-solution (indigenous consortium)");
  row("Origin", "Derived from dung & urine of indigenous Indian cows; native bacteria, fungi, natural fungicides & larvicides");
  row("Microbial count", "≈ 4×10^12 microbes / ml");
  row("Dosage", "1–2 litres per tonne of waste (application-dependent)");
  row("Production", "On-site bio-culture production supported for large volumes");

  section("PERFORMANCE SPECIFICATION");
  row("Odour control", "95% on day one; 100% within one week; neutralised in 2–5 min on application");
  row("Weight/volume reduction", "Up to 70% of treated waste");
  row("Decomposition", "3–4 weeks vs 3–4 months naturally");
  row("Emissions", "Neutralises methane (CH4), hydrogen sulphide (H2S) and ammonia (NH3)");
  row("Bio-CNG", "20–30% increase in biogas generation");

  section("COMPLIANCE & CERTIFICATION");
  row("Certification", "ISO 14001:2015 (Environmental Management)");
  row("Alignment", "Swachh Bharat Mission; supports NGT compliance and ESG reporting");

  section("APPLICATIONS");
  row("Suitable for", "Legacy landfills & dumpsites; bio-mining; RDF / cement plants; Bio-CNG; STP / wastewater; food, dairy, poultry & fisheries waste; public sanitation");

  // Page 2 — procurement boilerplate
  doc.addPage();
  header();
  y = 128;
  doc.setTextColor(...INK);
  doc.setFont("times", "normal");
  doc.setFontSize(20);
  doc.text("Suggested procurement clauses", M, y);
  y += 16;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(...SLATE);
  doc.text("Copy the clauses below directly into tender / RFP documents.", M, y + 14);
  y += 40;

  const clauses = [
    "The bio-solution shall be a liquid microbial consortium of indigenous origin with a microbial count of not less than 4×10^12 microbes/ml.",
    "The solution shall achieve at least 95% odour reduction within 24 hours of application and near-complete odour control within seven (7) days, verified on-site.",
    "The solution shall accelerate decomposition of organic waste, achieving up to 70% weight/volume reduction over the treatment period.",
    "The solution shall neutralise methane, hydrogen sulphide and ammonia emissions at the treatment site.",
    "The supplier shall hold ISO 14001:2015 certification and demonstrate prior municipal deployment experience.",
    "The supplier shall provide application methodology, dosage schedule and periodic performance reporting for the contract duration.",
    "Where volumes require, the supplier shall support on-site bio-culture production to optimise cost per tonne.",
  ];
  doc.setFontSize(10);
  clauses.forEach((c, i) => {
    doc.setTextColor(...TERRA);
    doc.setFont("helvetica", "bold");
    doc.text(`${i + 1}.`, M, y);
    doc.setTextColor(...INK);
    doc.setFont("helvetica", "normal");
    const lines = doc.splitTextToSize(c, W - M - 70);
    doc.text(lines, M + 22, y);
    y += lines.length * 14 + 12;
  });

  // Footer on both pages
  const footer = () => {
    doc.setDrawColor(210, 210, 200);
    doc.line(M, 792, W - M, 792);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.setTextColor(...STONE);
    doc.text("Fresh Earth · Exotic Buildcon SPV LLP  |  +91 98995 34141  |  care@fresh-earth.com", M, 808);
    doc.text("1044P, LGF, Sector 47, Gurugram, Haryana 122018 · India", M, 820);
  };
  footer();
  doc.setPage(1);
  footer();

  doc.save("FreshEarth-OED-Tender-Spec-Sheet.pdf");
}
